function filterVendors(vendorSection) {
  const vendorButtons = vendorSection.querySelectorAll('.vendors__tag-button');
  const vendors = vendorSection.querySelectorAll('.vendor');

  vendorButtons.forEach(button => {
    const id = button.dataset.id;
    button.addEventListener('click', e => {
      vendors.forEach(vendor => {
        const ids = vendor.dataset.terms ? vendor.dataset.terms.split(',') : [];
        const otherButtons = Array.from(vendorButtons).filter(button => button.dataset.id !== id);
        button.classList.add('active');
        otherButtons.forEach(button => {
          if (button.classList.contains('active')) button.classList.remove('active')
        });
        if (ids.includes(id)) {
          vendor.style.display = 'flex';
          // button.classList.add('active');
        } else {
          vendor.style.display = 'none';
          // button.classList.remove('active');
        }
      });
    });
  });

  const vendorButton = document.getElementById('vendor-clear');
  vendorButton.addEventListener('click', e => {
    vendors.forEach(vendor => vendor.style.display = 'flex');
  });
}

export default filterVendors;